import styled, { css } from 'styled-components';

import { setSvgColor } from 'styles/mixins';

export const Container = styled.div`
  width: '100%';
  min-height: 120px;
  display: flex;
  flex-direction: row;
  overflow: auto;

  ${({ theme }) => css`
    gap: ${theme.padding.default};
    padding-bottom: ${theme.padding.extraSmall};
  `}
`;

export const ImageContainer = styled.div`
  width: 120px;
  height: 120px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;
  position: relative;

  img {
    height: 100%;
    object-fit: contain;
    object-position: center;
  }

  ${({ theme }) => css`
    border-radius: ${theme.borderRadius.biggest};
    background-color: ${theme.colors.grey.main};
  `}
`;

export const RemoveButton = styled.button`
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  outline: none;
  cursor: pointer;
  top: 0;
  right: 0;
  position: absolute;

  ${({ theme }) => css`
    ${setSvgColor(theme.colors.white.main)};
    background-color: rgba(7, 8, 6, 0.8);
    border-radius: 0px 0px 0px ${theme.borderRadius.biggest};

    &:hover {
      ${setSvgColor(theme.colors.white.hover)};
    }

    &:active {
      ${setSvgColor(theme.colors.white.active)};
    }
  `}
`;
